import BaseIcon from './base-icon';

class SlidersIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="32" stroke-width="2" viewBox="0 0 32 32" fill="none">
        <path d="M8 4V28" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="8" cy="10" r="2" fill="currentColor" />
        <path d="M16 4V28" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="16" cy="16" r="2" fill="currentColor" />
        <path d="M24 4V28" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="24" cy="22" r="2" fill="currentColor" />
      </svg>
    `;
  }
}

customElements.define('sliders-icon', SlidersIcon);
